import { render, staticRenderFns } from "./GenericDataWidget.vue?vue&type=template&id=737a8ba0&scoped=true"
import script from "./GenericDataWidget.vue?vue&type=script&lang=js"
export * from "./GenericDataWidget.vue?vue&type=script&lang=js"
import style0 from "./GenericDataWidget.vue?vue&type=style&index=0&id=737a8ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a8ba0",
  null
  
)

export default component.exports